const TRANSLATIONS = {
  fr: {
    "settings.global":     "Paramètres de l'application",
    "settings.ui_lang":    "Langue de l'interface",
    "settings.accent":     "Couleur d'accent",
    "settings.accent_reset": "Réinitialiser la couleur",
    "settings.reply":      "Configuration de la réponse",
    "settings.reply_lang": "Langue de rédaction",
    "analysis.title":      "Analyse de l'email",
    "analysis.summary":    "Résumé contextuel",
    "analysis.keypoints":  "Points clés extraits",
    "translate.title":     "Traduction",
    "translate.target":    "Traduire en",
    "translate.toggle":    "Traduire l'email",
    "translate.empty":     "Aucun contenu à traduire.",
    "tab.edit":            "Édition",
    "tab.translate":       "Traduction",
    "btn.close":           "Fermer",

    "context.from":        "De :",
    "context.to":          "À :",
    "context.draft":       "Brouillon",
    "context.select":      "Sélectionnez un email",

    "status.ready":        "Prêt",
    "status.analyzing":    "Analyse en cours...",
    "status.loading":      "IA en cours...",
    "status.done":         "Terminé",
    "status.error":        "Erreur",
    "status.inserted":     "Inséré !",
    "status.opened":       "Réponse ouverte !",
    "status.nothing":      "Rien à coller",
    "status.impossible":   "Action impossible",
    "status.copy.error":   "Erreur copie",
    "status.unauthorized": "Accès non autorisé",
    "ner.title":           "Points Clés détectés",
    "ner.none":            "Aucun point clé détecté.",
    "ner.unavailable":     "Info non disponible.",
    "ner.error":           "Erreur d'analyse.",
    "options.language":    "Langue",
    "options.tone":        "Ton",
    "options.length":      "Longueur",
    "tone.professional":   "Professionnel",
    "tone.friendly":       "Amical",
    "tone.direct":         "Direct",
    "length.short":        "Court",
    "length.medium":       "Moyen",
    "length.long":         "Long",
    "length.full":         "Exhaustif",

    "btn.summarize":       "Résumer",
    "btn.draft":           "Générer une réponse",
    "btn.paste":           "Coller dans Outlook",
    "btn.use_as_mail":     "Utiliser comme email",
    "btn.copy":            "Copier",

    "chat.empty_title":    "Rédiger une réponse",
    "chat.empty_hint":     "Envoyez un message vide pour laisser l'IA proposer une première version, ou indiquez vos consignes.",
    "chat.placeholder":          "Modification…",
    "chat.first_message_hint":   "(brouillon initial)",
    "chat.send":           "Envoyer",

    "result.title":        "Résultat",
    "result.error":        "Une erreur est survenue. Vérifiez la connexion.",
    "result.unauthorized": "Non autorisé. Contactez votre administrateur.",
  },
  en: {
    "status.ready":        "Ready",
    "status.analyzing":    "Analyzing...",
    "status.loading":      "AI processing...",
    "status.done":         "Done",
    "status.error":        "Error",
    "status.inserted":     "Inserted!",
    "status.opened":       "Reply opened!",
    "status.nothing":      "Nothing to paste",
    "status.impossible":   "Action unavailable",
    "status.copy.error":   "Copy error",
    "status.unauthorized": "Unauthorized",
    "ner.title":           "Key Points detected",
    "ner.none":            "No key points detected.",
    "ner.unavailable":     "Info unavailable.",
    "ner.error":           "Analysis error.",
    "options.language":    "Language",
    "options.tone":        "Tone",
    "options.length":      "Length",
    "tone.professional":   "Professional",
    "tone.friendly":       "Friendly",
    "tone.direct":         "Direct",

    "settings.global":     "App Settings",
    "settings.ui_lang":    "Interface Language",
    "settings.accent":     "Accent Color",
    "settings.accent_reset": "Reset color",
    "settings.reply":      "Reply Configuration",
    "settings.reply_lang": "Draft Language",
    "analysis.title":      "Email Analysis",
    "analysis.summary":    "Contextual Summary",
    "analysis.keypoints":  "Extracted Key Points",
    "translate.title":     "Translation",
    "translate.target":    "Translate into",
    "translate.toggle":    "Translate email",
    "translate.empty":     "No content to translate.",
    "tab.edit":            "Editing",
    "tab.translate":       "Translation",
    "btn.close":           "Close",

    "context.from":        "From:",
    "context.to":          "To:",
    "context.draft":       "Draft",
    "context.select":      "Select an email",

    "length.short":        "Short",
    "length.medium":       "Medium",
    "length.long":         "Long",
    "length.full":         "Full",

    "btn.summarize":       "Summarize",
    "btn.draft":           "Reply",
    "btn.paste":           "Paste in Outlook",
    "btn.use_as_mail":     "Use as mail",
    "btn.copy":            "Copy",

    "chat.empty_title":    "Draft a reply",
    "chat.empty_hint":     "Send an empty message to let the AI propose a first draft, or describe what you want.",
    "chat.placeholder":          "Refinement…",
    "chat.first_message_hint":   "(initial draft)",
    "chat.send":           "Send",

    "result.title":        "Result",
    "result.error":        "An error occurred. Please check the connection.",
    "result.unauthorized": "Unauthorized. Please contact your administrator.",
  },
  de: {
    "status.ready":        "Bereit",
    "status.analyzing":    "Analyse läuft...",
    "status.loading":      "KI verarbeitet...",
    "status.done":         "Fertig",
    "status.error":        "Fehler",
    "status.inserted":     "Eingefügt!",
    "status.opened":       "Antwort geöffnet!",
    "status.nothing":      "Nichts einzufügen",
    "status.impossible":   "Aktion nicht möglich",
    "status.copy.error":   "Kopierfehler",
    "status.unauthorized": "Nicht autorisiert",
    "ner.title":           "Erkannte Punkte",
    "ner.none":            "Keine Punkte erkannt.",
    "ner.unavailable":     "Info nicht verfügbar.",
    "ner.error":           "Analysefehler.",
    "options.language":    "Sprache",
    "options.tone":        "Ton",
    "options.length":      "Länge",
    "tone.professional":   "Professionell",
    "tone.friendly":       "Freundlich",
    "tone.direct":         "Direkt",

    "settings.global":     "App-Einstellungen",
    "settings.ui_lang":    "Sprache der Benutzeroberfläche",
    "settings.accent":     "Akzentfarbe",
    "settings.accent_reset": "Farbe zurücksetzen",
    "settings.reply":      "Antwortkonfiguration",
    "settings.reply_lang": "Sprache des Entwurfs",
    "analysis.title":      "E-Mail-Analyse",
    "analysis.summary":    "Zusammenfassung",
    "analysis.keypoints":  "Extrahierte Schlüsselpunkte",
    "translate.title":     "Übersetzung",
    "translate.target":    "Übersetzen in",
    "translate.toggle":    "E-Mail übersetzen",
    "translate.empty":     "Kein Inhalt zum Übersetzen.",
    "tab.edit":            "Bearbeiten",
    "tab.translate":       "Übersetzung",
    "btn.close":           "Schließen",

    "context.from":        "Von:",
    "context.to":          "An:",
    "context.draft":       "Entwurf",
    "context.select":      "E-Mail auswählen",

    "length.short":        "Kurz",
    "length.medium":       "Mittel",
    "length.long":         "Lang",
    "length.full":         "Ausführlich",

    "btn.summarize":       "Zusammenfassen",
    "btn.draft":           "Antworten",
    "btn.paste":           "In Outlook einfügen",
    "btn.use_as_mail":     "Als E-Mail verwenden",
    "btn.copy":            "Kopieren",

    "chat.empty_title":    "Antwort verfassen",
    "chat.empty_hint":     "Sende eine leere Nachricht für einen ersten Entwurf oder beschreibe, was du möchtest.",
    "chat.placeholder":          "Anpassung…",
    "chat.first_message_hint":   "(erster Entwurf)",
    "chat.send":           "Senden",

    "result.title":        "Ergebnis",
    "result.error":        "Ein Fehler ist aufgetreten. Bitte prüfen Sie die Verbindung.",
    "result.unauthorized": "Nicht autorisiert. Kontaktieren Sie den Administrator.",
  },
};

export default TRANSLATIONS;
